import { useTranslation } from "react-i18next"
import { LanguageChangerV2 } from "@/features/language-changer-v2.tsx"
import { SystemFeatureText } from "@/pages/auth/login/components/system-feature-text.tsx"
import LogoImg from "@/shared/assets/images/logo.svg"
import { Navigate, Outlet } from "react-router-dom"
import { useGlobal } from "@/app/store/global"
import { Suspense } from "react"
import { Spinner } from "@/shared/components"

const AuthLayout = () => {
  const { t } = useTranslation("auth")
  const isAuthorized = useGlobal(useGlobal.selectAuthState)

  if (isAuthorized) return <Navigate to="/dashboard" />
  return (
    <Suspense
      fallback={
        <div className="h-[100vh] w-[100vw]">
          <Spinner />
        </div>
      }
    >
      <div className="auth-container overflow-hidden">
        <div className="auth-container__left-content">
          <div className="auth-container__left-content-inner">
            <Logo size="lg" className="mb-10" />
            <SystemFeatureText>{t("costReduction")}</SystemFeatureText>
            <SystemFeatureText>{t("increasedCompetitiveness")}</SystemFeatureText>
            <SystemFeatureText>{t("improvedReliability")}</SystemFeatureText>
          </div>
        </div>

        <div className="auth-container__right-content bg-[#EFF0F6]">
          <Outlet />
        </div>
        <LanguageChangerV2 />
      </div>
    </Suspense>
  )
}

type LogoProps = { size?: "lg" | "md" | "sm"; className?: string; logoOnly?: boolean }

export const Logo = ({ size = "md", className, logoOnly }: LogoProps) => {
  const { t } = useTranslation("common")
  return (
    <div className={`flex gap-4 items-center ${className ? className : ""}`}>
      <img src={LogoImg} width={size === "lg" ? 80 : size === "md" ? 48 : 30} alt="Yagona Energiya auditi tizimi Logo" />
      {logoOnly ? null : (
        <div className="flex flex-col truncate">
          {/* <p className={`uppercase font-semibold ${size === 'lg' ? 'text-3xl/8' : size === 'md' ? 'text-base' : 'text-lg'}`}>Energiya Samaradorlik</p> */}
          <p className={`uppercase ${size === "lg" ? "font-semibold text-2xl max-w-lg" : size === "md" ? "text-sm font-normal" : "text-lg"}`}>
            {t("logo_title")}
          </p>
        </div>
      )}
    </div>
  )
}

export default AuthLayout
